import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { DoctorBreadcrumbService } from '../../shared/breadcrumb.service';
import {
    GetMyPatientsQuery,
    Patients,
    raw_patient
} from 'src/app/models/patient-profile';
import { MessagesEgdUserQuery } from '../../../../models/Doctor';
import { DoctorsService } from '../../../../services/doctors.service';
import {
    ErrorModel,
    PromiseResult,
    ServerError
} from '../../../../models/PromiseResult';
import { HttpErrorResponse } from '@angular/common/http';
import { CountriesService } from '../../../../services/countries.service';
import { SpecialityService } from '../../../../services/speciality.service';
import { Specialty } from '../../../../models/Speciality';
import { reportspdf } from 'src/app/models/reportspdf';
import {
    AppointmentHistory,
    CosnultationHistoryDataQuery
} from 'src/app/models/appointment';
import { AppointmentService } from 'src/app/services/appointment.service';
import { Title } from '@angular/platform-browser';
import { DateUtilService, moment_duration } from '../../../../utilities/date.util.service';
import { TraceClassDecorator } from '@sentry/angular';
import { LazyLoadEvent, SelectItem } from 'primeng/api';
import { ProviderStateService } from 'src/app/services/provider-state.service';
import { URLS } from 'src/app/constant/constant';


@TraceClassDecorator()
@Component({
    selector: 'app-patients-s-admin',
    templateUrl: './patients-s-admin.component.html',
    styleUrls: [
        '../../../../../assets/css/custom-egd.css',
        '../../../../../assets/css/print-prescription.css'
    ],
    encapsulation: ViewEncapsulation.None
})
export class PatientsSAdminComponent implements OnInit {
    openDialog: boolean;
    patient_guid: string;
    consultation_id: number;
    patients: Patients[] = [];
    private user_guid: string;
    pre_patients: raw_patient[] = [];
    response: PromiseResult;
    serverError: ServerError;
    posting: boolean;
    loading: boolean;
    total_records: number = 0;
    query: GetMyPatientsQuery;
    doctor_list: SelectItem[] = [];
    specialties: SelectItem[] = [];
    countries: SelectItem[] = [];
    disabledDates: boolean = true;
    consultation_type: SelectItem[] = [];
    private readonly page_no: number;
    maxDate: Date = new Date();
    private readonly records_per_page: number;
    showPrescriptiond: string = 'showPrescription';
    showDoctorReportsd: string = 'showDoctorReports';
    printContent: string = 'print-content';
    param = new MessagesEgdUserQuery();
    prescriptionData: reportspdf;
    prescriptionSuccessd: boolean = null;

    doctorReportsData: reportspdf;
    doctorReportsSuccessd: boolean = null;
    displayModel: boolean = false;
    displayModel1: boolean = false;
    historyDialog: boolean = false;

    history_response: PromiseResult;
    history_serverError: ServerError;
    history_posting: boolean;
    history_error: ErrorModel;

    history: AppointmentHistory;

    loading1: boolean = false;
    loading2: boolean = false;
    loading3: boolean = false;
    is_uk_country: boolean = false;
    provider_id: string = "";
    slug: string = "";
    invalid_date_message: boolean = false;

    displayedColumns: string[] = [
        'name',
        'consultation_id',
        'age',
        'address',
        'country',
        'contact',
        'specialty',
        'opinion_type',
        'priority_type',
        'doctor_name',
        'email',
        'consultation_date',
        'req_no'
    ];

    constructor(
        private readonly router: Router,
        private readonly breadcrumbService: DoctorBreadcrumbService,
        private readonly doctorsService: DoctorsService,
        private readonly specialtyService: SpecialityService,
        private readonly countryService: CountriesService,
        private readonly titleService: Title,
        private readonly appointmentService: AppointmentService,
        private readonly dateUtil: DateUtilService,
        private readonly providerStateService: ProviderStateService
    ) {
        this.posting = false;
        this.page_no = 1;
        this.records_per_page = 10;
        
    }

    async ngOnInit(): Promise<void> {
        this.titleService.setTitle('Dashboard - Past Consultations');
        this.slug = this.providerStateService.getProviderSlug();
        if (URLS.IS_UK) {
            this.is_uk_country = true;
        }
        this.consultation_type = [
            {
                label: 'All',
                value: null
            },
            // {
            //     label: 'Expert Second Medical Opinion',
            //     value: 1
            // },
            {
                label: 'Primary Medical Consultation',
                value: 2
            },
            {
                label: 'Follow Up Consultation',
                value: 3
            },
            {
                label: 'Multi Specialty Consultation',
                value: 4
            },
            // {
            //     label: 'Diet and Nutrition',
            //     value: 5
            // }
        ];
        if (!this.is_uk_country) {
            this.consultation_type.push({
                label: 'Expert Second Medical Opinion',
                value: 1
            });
            this.consultation_type.push({
                label: 'Diet and Nutrition',
                value: 5
            });
        } else {
            this.consultation_type.push({
                label: 'Specialist Consultation',
                value: 1
            });
        }
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: [`/${this.slug}/doctor`] },
            { label: 'Past Consultations' }
        ]);
        this.provider_id = this.providerStateService.getProviderId();
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        };

        this.openDialog = false;
        this.user_guid = sessionStorage.getItem('userid');
        //only reseting the value not calling any api
        await this.InitFilter(false);
        this.patient_guid = null;
        this.consultation_id = null;
        this.loading = false;

        await this.GetDoctors();
        await this.FetchSpecialty();
        await this.FetchCountries();

    }

    Close() {
        this.patient_guid = null;
        this.consultation_id = null;
    }

    async InitFilter(call_api: boolean) {
        this.disabledDates = true;
        this.invalid_date_message = false;
        this.query = {
            user_guid: null,
            page_no: this.page_no,
            records_per_page: this.records_per_page,
            from_date: null,
            to_date: null,
            country_id: null,
            consultation_type_id: null,
            specialty_id: null,
            returnCount: true,
            first: 0,
        };
        if (call_api)
            await this.GetPatients(null);
    }

    async ResetResultModels(): Promise<void> {
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        };
    }

    async GetPatients(event: LazyLoadEvent) {
        await this.ResetResultModels();
        if (!this.disabledDates && (this.query.from_date == null || this.query.to_date == null)) {
            this.invalid_date_message = true;
            return;
        }
        if (this.invalid_date_message && ((this.query.from_date != null && this.query.to_date != null) || this.disabledDates))
            this.invalid_date_message = false;
        this.posting = true;
        this.loading = true;
        if (event != null) {
            this.query.page_no = event.first / event.rows + 1;
            this.query.records_per_page = event.rows;
        }
        else {
            this.query.page_no = 1;
            this.query.first = 0;
        }

        this.patients = [];
        await this.doctorsService
            .GetAllPatients(this.query)
            .toPromise()
            .then(async (result: PromiseResult) => {
                this.response = result;
                if (this.response.success) {
                    this.total_records = result.data.count;
                    this.pre_patients = result.data.rows;
                    await this.processpatients();
                }
                this.posting = false;
                this.loading = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.posting = false;
                this.loading = false;
            });
    }

    private async processpatients(): Promise<void> {
        const temp: Patients[] = [];
        this.pre_patients.forEach((patient, index) => {
            temp.push({
                sr_no:
                    index +
                    1 +
                    (this.query.page_no - 1) *
                    this.query.records_per_page,
                patient_guid: patient.patient_guid,
                consultation_id: patient.id,
                name:
                    patient.accounts.first_name +
                    ' ' +
                    (patient.accounts.middle_name == null ? '' : patient.accounts.middle_name) +
                    ' ' +
                    patient.accounts.last_name,
                age: this.dateUtil.diff(patient.accounts.date_of_birth, new Date(), moment_duration.years) + ' Yrs',
                address: patient.accounts.address_line_1,
                country: patient.accounts.country.country_name,
                contact: patient.accounts.primary_contact_number,
                specialty: patient.p_consultation_appointment.map((appt) => {
                    return appt.d_specialty_type.specialty_name;
                }),
                opinion_type: patient.priority_type.consultation_name,
                priority_type: patient.priority_type.priority_type,
                doctor_name: patient.p_consultation_appointment.map((appt) => {
                    return (
                        appt.egd_users.first_name +
                        ' ' +
                        appt.egd_users.last_name
                    );
                }),
                email: patient.accounts.user_patient.users.e_email,
                consultation_date: patient.consultation_date,
                req_no: patient.consultation_request_number
            });
        });
        this.patients = temp;
    }

    async GetDoctors(): Promise<void> {
        await this.ResetResultModels();
        this.posting = true;
        this.loading = true;
        await this.doctorsService.findUserList(this.param).toPromise().then(async (result: PromiseResult) => {
            this.doctor_list = [];
            if (result.success) {
                this.doctor_list = [];
                const temp: SelectItem[] = [{ label: 'All', value: null }];
                for (let i = 0; i < result.data.length; i++) {
                    temp.push(
                        {
                            label: result.data[i].first_name + " " + (result.data[i].middle_name == null ? '' : result.data[i].middle_name) + " " + result.data[i].last_name,
                            value: result.data[i].user_guid
                        }
                    )
                }
                this.doctor_list = temp;
            }
            else {
                this.response = result;
            }
            this.posting = false;
            this.loading = false;
        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.response.success = false;
            this.posting = false;
            this.loading = false;
        })
    }


    private async FetchSpecialty(): Promise<void> {
        this.posting = true;
        this.loading = true;
        await this.specialtyService
            .GetAllSpecialities(undefined, this.provider_id)
            .toPromise()
            .then((result) => {
                if (result.success) {
                    this.specialties = [];
                    let data: Specialty[] = result.data;
                    const temp: SelectItem[] = [{ label: 'All', value: null }];
                    data.forEach((specialty) => {
                        temp.push({
                            label: specialty.specialty_name,
                            value: specialty.id
                        });
                    });
                    this.specialties = temp;
                }
            });
        this.posting = false;
        this.loading = false;
    }

    private async FetchCountries(): Promise<void> {
        this.posting = true;
        this.loading = true;
        await this.countryService
            .getCountries(this.provider_id)
            .toPromise()
            .then((result) => {
                this.countries = [];
                const temp: SelectItem[] = [{ label: 'All', value: null }];
                for (const country of result)
                    temp.push({
                        label: country.country_name,
                        value: country.id
                    });
                this.countries = temp;
                this.posting = false;
                this.loading = false;
            });
    }

    ShowProfile(patient: Patients) {
        this.loading1 = true;
        this.consultation_id = patient.consultation_id;
        this.patient_guid = patient.patient_guid;
        this.loading1 = false;
        this.openDialog = true;
    }

    RouterNavigation(path: string) {
        this.router.navigate(['/' + this.slug + '/doctor/' + path]);
    }

    private async GetPrescriptionData() {
        await this.doctorsService
            .GetDoctorReportspdf(
                this.patient_guid,
                this.consultation_id,
                'prescription'
            )
            .toPromise()
            .then((result) => {
                this.prescriptionSuccessd = result.success;
                if (result.success) {
                    this.response = result;
                    this.prescriptionData = result.data;
                }
                this.displayModel = true;
            });
    }

    private async GetDoctorReportsData() {
        await this.doctorsService
            .GetDoctorReportspdf(
                this.patient_guid,
                this.consultation_id,
                'report'
            )
            .toPromise()
            .then((result) => {
                this.doctorReportsSuccessd = result.success;
                if (result.success) {
                    this.response = result;
                    this.doctorReportsData = result.data;
                }
                this.displayModel1 = true;
            });
    }

    print() {
        window.print();
    }

    async CloseDialog(): Promise<void> {
        this.displayModel = false;
        this.displayModel1 = false;
    }

    async gotoReportpdf(patient_row: Patients) {
        this.loading2 = true;
        this.patient_guid = patient_row.patient_guid;
        this.consultation_id = patient_row.consultation_id;

        await this.GetDoctorReportsData();
        this.loading2 = false;
        // this.displayModel1 = true;
        //  window.open('/doctorreportpdf','_blank');
    }

    async gotoprescription(patient_row: Patients) {
        this.loading3 = true;
        this.patient_guid = patient_row.patient_guid;
        this.consultation_id = patient_row.consultation_id;

        await this.GetPrescriptionData();
        // this.displayModel = true;
        this.loading3 = false;
        // this.prescriptionComp.ShowDialog();

        //await this.RouterNavigation('prescription');
        //  window.open('/doctorreportpdf','_blank');
    }

    async getConsultationsHistoryData(data: Patients) {
        this.history_posting = true;
        let history_query_data: CosnultationHistoryDataQuery = {
            patient_guid: data.patient_guid,
            user_guid: this.user_guid,
            consultation_id: data.consultation_id
        };

        this.appointmentService
            .getCosnultationHistory(history_query_data)
            .toPromise()
            .then((result) => {
                this.history_response = result;
                if (result.success) {
                    this.history = result.data;
                    this.historyDialog = true;
                } else if (!this.history_response.success) {
                    this.history_error = result.error;
                }
                this.history_posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.history_serverError = error.error;
                this.history_response.success = false;
                this.history_posting = false;
            });
    }
}
